import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { KeyRound, Save, ShieldCheck, WalletCards } from "lucide-react";

const EMPTY = {
  provider: "yokke",
  mdr_percent: 0.7,
  settlement_days: 1,
  is_production: true,
  merchant_id: "",
  server_key: "",
  client_key: "",
  yokke_client_key: "",
  yokke_client_secret: "",
  yokke_private_key_pem: "",
  yokke_partner_id: "",
  yokke_merchant_id: "",
  yokke_terminal_id: "",
  yokke_channel_id: "02",
};

export default function PlatformTransactionQrisPanel() {
  const [form, setForm] = useState(EMPTY);
  const [saving, setSaving] = useState(false);
  const [testing, setTesting] = useState(false);

  const load = async () => {
    try {
      const response = await api.get("/admin/platform-transaction-qris");
      setForm({ ...EMPTY, ...(response.data || {}), server_key: "", yokke_client_secret: "", yokke_private_key_pem: "", is_production: true });
    } catch (error) {
      toast.error(error?.response?.data?.detail || "Gagal memuat QRIS transaksi mitra");
    }
  };
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const save = async () => {
    setSaving(true);
    try {
      const response = await api.put("/admin/platform-transaction-qris", { ...form, is_production: true, settlement_days: 1 });
      setForm({ ...EMPTY, ...(response.data || {}), server_key: "", yokke_client_secret: "", yokke_private_key_pem: "", is_production: true });
      toast.success("QRIS transaksi mitra & MDR tersimpan");
    } catch (error) {
      toast.error(error?.response?.data?.detail || "Gagal menyimpan konfigurasi");
    } finally { setSaving(false); }
  };

  const test = async () => {
    setTesting(true);
    try {
      await api.post("/admin/platform-transaction-qris/test");
      toast.success(`Koneksi ${String(form.provider || "").toUpperCase()} Production valid`);
    } catch (error) {
      toast.error(error?.response?.data?.detail || "Test koneksi gagal");
    } finally { setTesting(false); }
  };

  return (
    <section className="mt-8 border border-border bg-white" data-testid="platform-transaction-qris-panel">
      <div className="border-b border-border p-6">
        <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-[#002FA7]"><WalletCards className="h-4 w-4"/>QRIS Transaksi Mitra</div>
        <h2 className="mt-2 font-display text-3xl font-black tracking-tighter">QRIS Dinamis KRAYA / Owner</h2>
        <p className="mt-2 max-w-3xl text-sm leading-6 text-zinc-500">Terpisah dari QRIS pembayaran langganan. Jika dipilih mitra, dana transaksi POS masuk melalui konfigurasi ini dan masuk antrean settlement H+1.</p>
      </div>

      <div className="grid gap-6 p-6 lg:grid-cols-2">
        <div className="space-y-4">
          <div><label className="overline">Provider</label><select value={form.provider} onChange={(e)=>setForm({...form,provider:e.target.value})} className="mt-1 w-full border border-border px-3 py-2.5"><option value="yokke">Yokke / Mandiri</option><option value="midtrans">Midtrans — Production Only</option></select></div>
          <div className="grid grid-cols-2 gap-3">
            <div><label className="overline">MDR (%)</label><input type="number" min="0" max="100" step="0.01" value={form.mdr_percent ?? 0} onChange={(e)=>setForm({...form,mdr_percent:e.target.value})} className="mt-1 w-full border border-border px-3 py-2.5"/></div>
            <div><label className="overline">Settlement</label><div className="mt-1 border border-border bg-zinc-50 px-3 py-2.5 text-sm font-bold">H+1</div></div>
          </div>
          <div className="border border-emerald-200 bg-emerald-50 p-3 text-xs font-semibold text-emerald-800"><ShieldCheck className="mr-1 inline h-4 w-4"/>Environment dikunci ke PRODUCTION.</div>
        </div>

        <div className="space-y-3">
          {form.provider === "midtrans" ? <>
            <div><label className="overline">Server Key</label><input type="password" value={form.server_key || ""} onChange={(e)=>setForm({...form,server_key:e.target.value})} placeholder={form.has_server_key ? "Tersimpan — kosongkan jika tidak diubah" : "Mid-server-..."} className="mt-1 w-full border border-border px-3 py-2 font-mono text-xs"/></div>
            <div className="grid grid-cols-2 gap-3"><div><label className="overline">Client Key</label><input value={form.client_key || ""} onChange={(e)=>setForm({...form,client_key:e.target.value})} className="mt-1 w-full border border-border px-3 py-2 font-mono text-xs"/></div><div><label className="overline">Merchant ID</label><input value={form.merchant_id || ""} onChange={(e)=>setForm({...form,merchant_id:e.target.value})} className="mt-1 w-full border border-border px-3 py-2 font-mono text-xs"/></div></div>
          </> : <>
            <div className="grid grid-cols-2 gap-3"><div><label className="overline">X-CLIENT-KEY</label><input value={form.yokke_client_key || ""} onChange={(e)=>setForm({...form,yokke_client_key:e.target.value})} className="mt-1 w-full border border-border px-3 py-2 font-mono text-xs"/></div><div><label className="overline">Client Secret</label><input type="password" value={form.yokke_client_secret || ""} onChange={(e)=>setForm({...form,yokke_client_secret:e.target.value})} placeholder={form.has_yokke_client_secret ? "Tersimpan — kosongkan jika tidak diubah" : ""} className="mt-1 w-full border border-border px-3 py-2 font-mono text-xs"/></div></div>
            <div><label className="overline">Private Key PEM</label><textarea rows={5} value={form.yokke_private_key_pem || ""} onChange={(e)=>setForm({...form,yokke_private_key_pem:e.target.value})} placeholder={form.has_yokke_private_key ? "Tersimpan — kosongkan jika tidak diubah" : "-----BEGIN PRIVATE KEY-----"} className="mt-1 w-full border border-border px-3 py-2 font-mono text-[10px]"/></div>
            <div className="grid grid-cols-3 gap-3"><div><label className="overline">X-PARTNER-ID</label><input value={form.yokke_partner_id || ""} onChange={(e)=>setForm({...form,yokke_partner_id:e.target.value})} className="mt-1 w-full border border-border px-3 py-2 font-mono text-xs"/></div><div><label className="overline">Merchant ID</label><input value={form.yokke_merchant_id || ""} onChange={(e)=>setForm({...form,yokke_merchant_id:e.target.value})} className="mt-1 w-full border border-border px-3 py-2 font-mono text-xs"/></div><div><label className="overline">Terminal ID</label><input value={form.yokke_terminal_id || ""} onChange={(e)=>setForm({...form,yokke_terminal_id:e.target.value})} className="mt-1 w-full border border-border px-3 py-2 font-mono text-xs"/></div></div>
          </>}
          <div className="grid grid-cols-2 gap-2 pt-2"><button onClick={save} disabled={saving} className="inline-flex items-center justify-center gap-2 bg-[#002FA7] px-4 py-3 text-sm font-semibold text-white disabled:opacity-50"><Save className="h-4 w-4"/>{saving ? "Menyimpan…" : "Simpan"}</button><button onClick={test} disabled={testing || !form.configured} className="inline-flex items-center justify-center gap-2 border border-zinc-900 px-4 py-3 text-sm font-semibold disabled:opacity-50"><KeyRound className="h-4 w-4"/>{testing ? "Mengecek…" : "Test Koneksi"}</button></div>
        </div>
      </div>
    </section>
  );
}
